import { render, staticRenderFns } from "./DtStudentQuantitation.vue?vue&type=template&id=ad38c6f0&"
import script from "./DtStudentQuantitation.vue?vue&type=script&lang=js&"
export * from "./DtStudentQuantitation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports